import React from 'react';
import PropTypes from 'prop-types';

const InfoIcon = ({ size, fill = '#00BCE7', ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <polygon id="path-1" points="40.0001119 40 40.0001119 0 0.000111857096 0 0.000111857096 40" />
    </defs>
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="symbols" transform="translate(-1009.000000, -65.000000)">
        <g id="Group" transform="translate(1009.000000, 65.000000)">
          <ellipse id="Oval-58" fill="#FFFFFF" cx="20" cy="20" rx="20" ry="20" />
          <g id="HELP" transform="translate(0.000000, 0.000000)">
            <mask id="mask-2" fill="white">
              <polygon id="path-1" points="40.0001119 40 40.0001119 0 0.000111857096 0 0.000111857096 40" />
            </mask>
            <g id="Clip-2" />
            <path d="M23.7353978,11.012491 C23.7306439,8.92484437 22.032287,7.22820063 19.9524239,7.23366754 C17.9060762,7.23889676 16.2310139,8.93102435 16.2274484,10.9968034 C16.2238829,13.0991869 17.9020354,14.7939291 19.9828493,14.7901261 C22.0420327,14.7860853 23.7401518,13.0766062 23.7353978,11.012491 L23.7353978,11.012491 Z M23.1506592,25.4774604 C23.1506592,23.5438379 23.1513723,21.6104532 23.1504215,19.6768308 C23.1499461,18.642634 22.3693437,17.8351951 21.3317891,17.8187944 C20.416887,17.8045329 19.5010341,17.8054836 18.5858944,17.8185567 C17.5319386,17.8335313 16.7613196,18.6114964 16.7601311,19.6613809 C16.7558525,23.5179295 16.7560902,27.3747159 16.7598934,31.2315023 C16.7608442,32.2847145 17.5507168,33.085498 18.605861,33.1004726 C19.5107798,33.1135456 20.4164116,33.1159225 21.3210927,33.0997595 C22.37386,33.0812195 23.1501838,32.2702153 23.1506592,31.21629 C23.1511346,29.3033468 23.1506592,27.3904036 23.1506592,25.4774604 L23.1506592,25.4774604 Z M19.9777458,40 C8.92713572,39.9897793 -0.125379522,31.0152517 0.00131385641,19.7527034 C0.123490961,8.87497802 8.96659369,-0.0947956664 20.19524,0.000756418278 C31.1524345,0.0941692772 40.07065,8.98907006 39.9995781,20.1372887 C39.929457,31.1359991 31.0350114,39.9988115 19.9777458,40 L19.9777458,40 Z" id="Fill-1" fill={fill} mask="url(#mask-2)" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

InfoIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string
};

export default InfoIcon;
